import React from "react";
import { useT, SUPPORTED_LANGS } from "../lib/i18n";
import { Globe } from "lucide-react";

const LABELS = { en: "EN", es: "ES" };

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useT();
  return (
    <div className={`inline-flex items-center gap-1 rounded-md border border-slate-800 bg-slate-900 p-0.5 ${className}`} data-testid="language-toggle">
      <Globe className="ml-1.5 h-3.5 w-3.5 text-slate-500" />
      {SUPPORTED_LANGS.map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`rounded px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider transition-colors ${
            lang === l
              ? "bg-emerald-500/15 text-emerald-300"
              : "text-slate-400 hover:text-slate-200"
          }`}
          data-testid={`lang-${l}-btn`}
        >
          {LABELS[l]}
        </button>
      ))}
    </div>
  );
}
